import { store, storeFuns, api, apiFuns, utils } from "sw-hic";

storeFuns.init({
  state: {
    enum: {
      DeptType: ["临床", "医技", "药剂", "职能"],
      TreatType: ["住院", "门诊", "急诊"],
      examineStandardType: ["检查", "检验", "治疗", "材料", "其它"],
      ExamineSrcType: ["标准编码", "检治集"],
      DbType: ["SQLServer", "MySQL", "PostgreSQL", "Oracle"],
      DbValueType: ["文本", "整数", "小数", "日期", "时间", "字典"],
      DbInputType: ["标签", "文本", "单选", "日期", "时间"],
      ReportType: ["通用", "首页", "字典"],
      DataBaseType: ["SQLServer", "Oracle", "MySQL", "PostgreSQL"],
      ResultType: ["对象", "列表", "分页列表"],
      SqlCode: ["hic", "patient", "ml"],
      SqlItemType: ["string", "int", "object", "list"],
      PageLayout: ["检索框", "纵向", "横向"],
    },
  },
});

api.Apply = apiFuns.genStandard("apply", "/api/md", true);

storeFuns.genDict(
  "Sys",
  () => api.Apply.query({ sort: "seq", asc: true }),
  "name",
  "code",
  "code",
  (store, dict) => {
    dict.items.unshift({
      code: "auth",
      shortCode: "auth",
      name: "认证中心",
      text: "认证中心",
      seq: 0,
    });
    store.commit("dict", dict);
    store.dispatch("loaders", "MySys"); // 再调用一边MySys加载
  }
);

api.TenantApply = apiFuns.genStandard("tenantApply", "/api/md", true);

storeFuns.genDict(
  "MySys",
  (storeRuntime) =>
    api.TenantApply.query({
      tenantId: storeRuntime.state.user.tenantId,
    }),
  "name",
  "code",
  "code",
  (store, dict) => {
    dict.items.forEach((item) => {
      item.text = utils.Dict.text(item.sysCode, "Sys");
      item.name = item.text;
      item.code = item.sysCode;
      item.value = item.code;
      return item;
    });
    store.commit("dict", dict);
  }
);

export default store;
